import { createApp } from 'vue';
import { useStoreProductContent } from '@components/store/elements/product_content';
import { useStoreProductGallery } from '@components/store/elements/product_gallary';
import { useStoreArticleBlock } from '@components/store/elements/article_block';

document.addEventListener('DOMContentLoaded', () => {
  useStoreArticleBlock();

  const articleBlocks = document.querySelectorAll(
    '.c-store-elements-articleblock'
  );
  articleBlocks.forEach(function (articleBlock) {
    const productContent = articleBlock.querySelector(
      '.c-store-elements-productcontent'
    ) as HTMLElement;
    const productId = productContent?.getAttribute('data-product-id') as string;
    const app = createApp({
      setup() {
        const { mainSlider, thumbsSlider } = useStoreProductGallery(productId);
        const { storeProductContentVariables, storeProductContentFunctions } =
          useStoreProductContent(productContent, mainSlider, thumbsSlider);
        return {
          ...storeProductContentVariables,
          ...storeProductContentFunctions,
        };
      },
    });
    app.mount(productContent);
  });
});
